import { render, staticRenderFns } from "./Userdetails.vue?vue&type=template&id=5ef6c47e&scoped=true&"
import script from "./Userdetails.vue?vue&type=script&lang=js&"
export * from "./Userdetails.vue?vue&type=script&lang=js&"
import style0 from "./Userdetails.vue?vue&type=style&index=0&id=5ef6c47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef6c47e",
  null
  
)

export default component.exports